<template>
  <v-col class="container" cols="auto">
    <v-card class="elevation-12 d-flex card" color="primary">
      <div class="image">
        <img :src="logos.login" />
      </div>

      <div class="login">
        <div class="logo mb-5">
          <img :src="logos.logo" class="logoImg" />
        </div>
        <login-form></login-form>
        <div class="texts-footer">
          {{ title }}
        </div>
      </div>
    </v-card>
  </v-col>
</template>
<script>
import LoginForm from "./FormCE";
import { mapGetters } from "vuex";

export default {
  components: {
    LoginForm,
  },
  computed: {
    ...mapGetters(["logos", "title"]),
  },
  data() {
    return {
      logo: this.$store.state.logo,
    };
  },
};
</script>
<style lang="scss" scoped>
.container {
  margin: 0 auto;
}
.card {
  max-height: 600px;
  width: 1000px;
  border-radius: 10px;
}
.texts-footer {
  color: var(--corPrimaria);
  font-size: 14px;
  text-align: center;
  margin-top: 10px;
}

.image {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 50%;
  border-right: 1px solid #d3d3d3;
  img {
    object-fit: cover;
    width: 100%;
    height: 100%;
    object-position: right;
  }
}
.logo {
  display: flex;
  justify-content: center;
  align-items: center;
}

.logoImg {
  width: 350px;
  margin-top: 20px;
}

.login {
  background-color: #fff;
  color: #000;
  width: 50%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  margin: 0 auto;
  border-radius: 0px 10px 10px 0px !important;
}

@media screen and (max-width: 760px) {
  .image {
    display: none;
  }

  .login {
    width: 100%;
    border-radius: 10px !important;

    .logo {
      img {
        width: 70%;
      }
    }
  }

  .texts-footer {
    margin-bottom: 10px;
  }
}
</style>
